import { envConstants } from "../Utils/constants";

const awsConfig = {
    Auth: {
      Cognito: {
        region: "us-east-1",
        userPoolId: envConstants.COGNITO_USER_POOL_ID,
        userPoolClientId: envConstants.COGNITO_CLIENT_ID,
        loginWith: {
          oauth: {
            domain: envConstants.AUTH_DOMAIN,
            scopes: ['openid', 'profile', 'email', 'phone'],
            redirectSignIn: envConstants.AUTH_CALLBACK_URL,
            redirectSignOut: envConstants.AUTH_SIGNOUT_URL,
            responseType: 'code'
          }
        }
      }
    }
  };

export default awsConfig;